// extracted by mini-css-extract-plugin
export default {"container":"container--S4OGq","second-view":"second-view--uWzHl","secondView":"second-view--uWzHl","controls":"controls--H5eMt"};